export const VARIABLE_REGEX_GLOBAL = /\${variable\.[^{}]+}/g
export const VARIABLES_REGEX_SINGULAR = /\${variable\.([^}]+)}/
